<template>
  <div class="index">
    <van-nav-bar
        title="网点信息"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="van-doc-demo-block__card">
      <van-panel title="网点信息" desc="江山市江城管道燃气有限公司" >
        <div class="doc_title">
          城区营业厅<br>
          地址：江山市江城北路147号（三毛土菜馆隔壁）<br>
          服务热线：0570-4517517<br><br>

          贺村营业点<br>
          地址：贺村镇贺福路29号（天一宾馆公交车站）<br>
          服务热线：0570-4517345<br><br>

          城北左邻右舍IC卡充值点（文苑路加盟店）<br>
          地址：文苑路140号<br><br>

          上班时间：周一至周日 （法定节假日除外）<br>
          冬令时：上午8:30-12:00  下午14:00-17:30<br>
          夏令时：上午8:30-12:00  下午14:30-18:00<br><br>
        </div>
      </van-panel>
    </div>



  </div>
</template>
<script>
export default {
  name: 'page_bind',
  data() {
    return {

    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    }

  },
  mounted () {

  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.doc-demo-block__card {
  margin: 16px 12px 0px;
  overflow: hidden;
  border-radius: 8px;
}
.doc_title {
  margin: 0;
  padding: 22px 16px 0px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>